import { gql } from '../../../__generated__/graphql/catalog'

// People really need to stop making such generic and large fragments.
// Just query what you need for your feature. Its not that difficult to write a query from scratch.
export const GET_DEPRECATED_FEATURED_PRODUCT_V2 = gql(`
  query ZidiFeaturedProductV2(
    $productGroupHandle: String!
    $color: String
    $fit: String
    $selectedColor: String
    $selectedFit: String
  ) {
    productGroup(
      handle: $productGroupHandle
      selectedColor: $selectedColor
      selectedFit: $selectedFit
    ) {
      id
      featuredProduct(color: $color, fit: $fit) {
        ...DeprecatedFeaturedProduct
        careInstructions
        collectionLinks {
          nodes {
            text
            href
          }
        }
        fitModel {
          description
          height
          images
          name
          pantsSize
          topSize
        }
        fitModelsDescriptions
        rawMaterials
        rtfFeatures
      }
    }
  }
`)
